export const URLS = {
  ORDER_API: "https://order.sofology.co.uk",
  SOFOLOGY_HOME: "https://www.sofology.co.uk",
  SOFOLOGY_REX: "https://api.sofology.co.uk/api/rex/",
  SOFOLOGY_API: "https://api.sofology.co.uk/api/",
  MY_SOFOLOGY_API: "https://customerexperience.sofology.co.uk/api/",
  MY_SOFOLOGY_LOGIN: "https://www.sofology.co.uk/mysofology-login",
  SOP_API: "https://salesorderprocessing.sofology.co.uk/api/",
  TEMPLATES_ENDPOINT: {
    GET_ALL:
      "https://www-my-sofology-co-uk.euwest01.umbraco.io/umbraco/api/MetaData/GetContentGroupedByTemplate",
  },
  HYBRIS_OAUTH_TOKEN:
    "https://mgmt.g.sofology.co.uk/swkcommercewebservices/oauth/token",
  HYBRIS_COMMERCE:
    "https://mgmt.g.sofology.co.uk/swkcommercewebservices/v2/cmsSofaworksSite/",
  MY_ACCOUNT_URL: "https://myaccount.sofology.co.uk/api/",
  MY_ACCOUNT_LOGOUT_URL: "https://myaccount.sofology.co.uk/Logout/",
  BASKET_URL: "https://www.sofology.co.uk/basket",
  PAYPAL: {
    ENV: "production",
    CLIENT: {
      sandbox:
        "AbdzWd3vpYMFTnAKFbZtcFnsOiKrivYlFazcm6gL_rkpylkZGjK2UytYCf0EwwrgtGGT952L7XOLOL0l",
      production:
        "AdWII6CQL0_7ALJl7KnyS4nBjFdpuo--PCmqJLgpdEaDzKkl26WeCZI52yD5flgKfsfkch1YDuYxMGxZ",
    },
  },
  ADYEN: {
    CUSTOMER_CREATE_PAYMENT_SESSION: "https://api.sofology.co.uk/api/payments/create-payment-session",
    SOFOLOGIST_CREATE_PAYMENT_SESSION: "https://portalapi.sofology.co.uk/api/payments/create-payment-session-as-sofologist",
    REDIRECT_URL: "https://my.sofology.co.uk/",
    ENVIRONMENT: 'live',
    CLIENT_KEY: 'live_HWHVQ36VO5E67GR3L2I2WQBBY4MIAM4S',
  }
};

export const APP_INFO = {
  CLIENT_ID:
    "125377059059-mn1rb1eku9lhecb5vn0rq8145nouftld.apps.googleusercontent.com",
  COOKIE_DOMAIN: ".sofology.co.uk",
  SHOW_ALT_DELIVEY_COVID_MESSAGE: false,
};



// WEBPACK FOOTER //
// ./src/config/LIVE.config.js